module.exports = __webpack_public_path__ + "img/sorting-arrow-down.f699aba5.svg";